var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BarChart',{style:({ height: _vm.height }),attrs:{"bar-chart-data":_vm.facilitiesPriorityChartData,"bar-chart-options":_vm.facilitiesStatusChartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }